export const AUTH_STORAGE_KEY = 'borasuite_admin_auth_v1'

export const LEGACY_AUTH_STORAGE_KEYS = [
  'bora_learn_auth_v1',
  'bora_auth_v1',
] as const

